import type { TVehicleDetails } from './types';

export const generateAlertMessage = ({ plateNumber, inService, needService, serviceComment }: TVehicleDetails) => {
  let baseMessage = '';
  if (needService) {
    baseMessage = `Vehicle ${plateNumber} needs service. Please plan trips with it only towards our auto service.`;
  } else if (inService) {
    baseMessage = `Vehicle ${plateNumber} is in service. Please do not plan trips with it.`;
  }
  if (serviceComment) {
    baseMessage += `\nComment: ${serviceComment}`;
  }
  return baseMessage;
};
